import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="C" transform="translate(11.000000, 5.000000)">
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
    <text font-weight="bold" x="34" y="65" fill="currentColor" fontSize="50px" fontFamily="Calibre, serif">
      C
    </text>
  </svg>
);

export default IconLoader;
